import { Account, Connection, PublicKey } from '@solana/web3.js';

export const GetOrderBookWithEvents = async (connection, market) => {
  let [bids, asks, events] = await Promise.all([
    market.loadBids(connection),
    market.loadAsks(connection),
    market.loadEventQueue(connection),
  ]);
  // console.log("[s], [b]", bids.getL2(100));
  // console.log("[s] MARKET ORDERBOOK");
  // L2 orderbook data
  

  let bidsArray = [];
  let asksArray = [];

  for (let [price, size] of asks.getL2(100)) {
    asksArray.push([price, size]);
  }
  for (let [price, size] of bids.getL2(100)) {
    bidsArray.push([price, size]);
  }
  // console.log({
  //   bids: bidsArray,
  //   asks: asksArray,
  //   currentPrice: bidsArray.length > 0 ? bidsArray[0][0] : 0
  // });
  
  return {
    bids: bidsArray,
    asks: asksArray,
    currentPrice: bidsArray.length > 0 ? bidsArray[0][0] : 0,
    events: events,
  }
}

export const GetRecentTrades = async (baseToken) => {
  console.log("Getting Recent Trades", baseToken);
  let url = "https://public-api.birdeye.so/defi/txs/token?address="+baseToken+"&offset=0&limit=50";
  let request = await fetch(url,{
    method: "GET",
    headers: {
      Authorization: "446c96a7-a090-4234-98fb-51bf5f2e8799",
      "content-type": "application/json",
      "accept": "application/json",
      "X-API-KEY":process.env.REACT_APP_CANDLESTICK_API_KEY
    }
  })
  let response = await request.json();
  return response.data.items;
}

